import type { ReactElement, ReactNode } from 'react';

/**
 * Fehlerhinweis mit `role="alert"` (§19.1, §23.2).
 *
 * `role="alert"` sorgt dafür, dass ein Bildschirmleser die Meldung ansagt, ohne dass der Fokus
 * springt. §19.1 verlangt klare Zustände und verständliche Meldungen; die Rolle einheitlich zu
 * setzen ist der einfachste Weg, das nicht zu vergessen.
 *
 * `ausfuehrlich` ist für die Anzeige nach §14.4 gedacht: schlägt eine Plausibilitätsprüfung beim
 * Schließen fehl, verlangt das Pflichtenheft im Backend einen **deutlichen** Fehler.
 */
export function Fehlermeldung({
  children,
  ausfuehrlich = false,
}: {
  children: ReactNode;
  ausfuehrlich?: boolean;
}): ReactElement {
  if (ausfuehrlich) {
    return (
      <div
        role="alert"
        className="border-fehler/50 bg-fehler/10 text-fehler rounded-md border p-3 text-sm font-medium"
      >
        {children}
      </div>
    );
  }

  return (
    <p role="alert" className="text-fehler text-sm font-medium">
      {children}
    </p>
  );
}
